/* eslint-disable */
import '@pidz/icons/public/style.css';
import { createPinia } from 'pinia';
import { initMSW } from '@pidz/mocking';
import { createApp } from 'vue';
import PidzComponents from '@pidz/new-components';
import App from './App.vue';
import { router } from '@web/router';
import VueGTag from 'vue-gtag';
import { Settings } from 'luxon';
import { useFeatureflagsStore, useBannersStore, useHealthStore, useToaster } from '@pidz/stores';
import { errorHandler } from '@pidz/utils';
import '../../../tailwind-index.css';

const init = async () => {
  initMSW();
  initFeatureFlags();
  initBanners();

  // Set the default zone in luxon
  Settings.defaultZone = 'Europe/Amsterdam'
  // Settings.throwOnInvalid = true
};

const initFeatureFlags = () => {
  const featureFlagsStore = useFeatureflagsStore();
  featureFlagsStore.initRemoteFlags();
}

const initBanners = () => {
  const bannersStore = useBannersStore();
  bannersStore.fetchBanners();
}

(async () => {
  const app = createApp(App)
    .use(createPinia())
    .use(PidzComponents)
    .use(VueGTag, {
      config: {
        id: import.meta.env.VITE_GOOGLE_ANALYTICS_WEB_MEASUREMENT_ID
      }
    }, router);
  if (router) {
    app.use(router);
  }
  await init();
  app.mount('#app');
})();

window.onunhandledrejection = (event: PromiseRejectionEvent | any) => {
  let response;

  if (event.reason.response) response = event.reason.response; // JSONRPC error
  if (event.response) response = event.response; // Rest error

  if (!response) return;

  if (response.data.status === 'MAINTENANCE') {
    useHealthStore().setBackendStatus('MAINTENANCE');
  } else { 
    if (response.data.error) {
      useToaster().addToaster(errorHandler(response.data.error.code), 7000);
    }
  }
}
